import { NavLink } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import LanguageStore from '../../store/LanguageStore';
import './sidebar.scss';

const Sidebar = observer(({ isOpen, onClose }) => {
    const t = LanguageStore.t;
    const { language } = LanguageStore;

    const menu = [
        {
            title: t('aboutUs'),
            link: '/about-us',
        },
        {
            title: language === 'ru' ? 'Каналы' : 'Channels',
            link: '/channels',
        },
        {
            title: language === 'ru' ? 'Видео' : 'Videos',
            link: '/videos',
        }
    ];

    return (
        <>
            {/* Overlay для закрытия при клике вне панели */}
            {isOpen && (
                <div 
                    className="sidebar__overlay" 
                    onClick={onClose}
                    aria-hidden="true"
                />
            )}
            
            {/* Боковая панель */}
            <aside className={`sidebar ${isOpen ? 'sidebar--open' : ''}`}>
                <div className="sidebar__header">
                    <h2 className="sidebar__title">
                        {language === 'ru' ? 'Меню' : 'Menu'}
                    </h2>
                    <button 
                        className="sidebar__close"
                        onClick={onClose}
                        aria-label={language === 'ru' ? 'Закрыть меню' : 'Close menu'}
                    >
                        ×
                    </button>
                </div>
                
                <nav className="sidebar__nav">
                    {menu.map((element, index) => {
                        return (
                            <NavLink
                                key={index}
                                to={element.link}
                                className={({ isActive }) => 
                                    isActive 
                                        ? "sidebar__item sidebar__item--active" 
                                        : "sidebar__item"
                                }
                                onClick={onClose}
                            >
                                {element.title}
                            </NavLink>
                        );
                    })}
                </nav>
            </aside>
        </>
    );
});

export default Sidebar;

